/* Testimonials slider (continuous autoplay + play/pause) is initialized in accessibility.js */


const playlist = document.querySelector(".video_play_list");

/* MUTE ALL */
function muteAllVideos() {

  if (!playlist) return;

  playlist.querySelectorAll(".full_video_new").forEach(function (item) {

    const video     = item.querySelector('video');
    const muteBtn   = item.querySelector('.mute_video');
    const unmuteBtn = item.querySelector('.unmute_video');

    if (!video || !muteBtn || !unmuteBtn) return;   // null guard

    video.muted = true;
    muteBtn.classList.remove('active');
    unmuteBtn.classList.add('active');

  });

}


/* VIDEO BUTTON CONTROLS (EVENT DELEGATION) */

if (playlist) {

  playlist.addEventListener("click", function (e) {

    const muteBtn = e.target.closest(".mute_video");
    const unmuteBtn = e.target.closest(".unmute_video");

    if (!muteBtn && !unmuteBtn) return;

    const parent = e.target.closest(".full_video_new");
    const video = parent.querySelector("video");
    const mute = parent.querySelector(".mute_video");
    const unmute = parent.querySelector(".unmute_video");

    /* MUTE BUTTON */
    if (muteBtn) {

      video.muted = true;

      mute.classList.remove("active");
      unmute.classList.add("active");

    }

    /* UNMUTE BUTTON */
    if (unmuteBtn) {

      const wasPlaying = !video.paused;

      /* MUTE OTHER VIDEOS ONLY */
      playlist.querySelectorAll("video").forEach(function (v) {
        if (v !== video) v.muted = true;
      });

      playlist.querySelectorAll(".full_video_new").forEach(function (item) {

        if (item !== parent) {

          item.querySelector(".mute_video").classList.remove("active");
          item.querySelector(".unmute_video").classList.add("active");

        }

      });

      video.muted = false;

      unmute.classList.remove("active");
      mute.classList.add("active");

      /* SAFARI STABILITY FIX */
      if (wasPlaying) video.play();

    }

  });

}


/* Video List End */